module.exports = __webpack_public_path__ + "img/icon-check-data.6c66ad45.svg";